export class BusinessConfigurationReaderListener {
  configurationRead = businessConfiguration => {};
}
